import React, {Component} from 'react'
import {Buffer} from "buffer"
import MainLayout from "../../components/layouts/MainLayout"
import {withRouter} from "../../hoc/withRouter"
import {UpdateFormStates} from "./types/UpdateOfferTypes"
import withAuth from "../../hoc/withAuth"
import {Button, Card, Col, Form, Input, Modal, Row} from "antd"
import Cookies from "universal-cookie"
import UpdateVehicleAndPromo from "../../components/offer/UpdateVehicleAndPromo"

export interface ReactiveOfferProps {
}

class ReactiveOffer extends Component<ReactiveOfferProps & any, UpdateFormStates> {
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString())
    private readonly initState!: UpdateFormStates
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())
    private token = new Cookies().get('_t')

    constructor(props: ReactiveOfferProps & any | any) {
        super(props)
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#')
        const picked = this.uDealer.find((o: { DealerCode: any }) => o.DealerCode === finalDealerCode)
        const companyCode = picked?.DealerCompany ?? "AMARTA"

        this.initState = {
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            companyCode: companyCode,
            offerCode: "",
            fetchProcess: false,
            showFormUpdateForm: false,
            updateProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dealerCode: data.value,
            offerCode: "",
            fetchProcess: false,
            showFormUpdateForm: false,
            updateProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
        })
    }

    cancelOffer = async () => {
        await this.promisedSetState({
            cancelOfferModal: true,
        })
    }

    defaultState = async () => {
        await this.promisedSetState({
            fetchProcess: false,
            showFormUpdateForm: false,
            updateProcess: false,
            offerStatus: "",
            cancelOfferModal: false,
        })
    }

    onFieldChange = <T extends keyof Pick<any, "offerCode">>(target: T, value: any) => {
        const currentState: any = {...this.state}
        switch (target) {
            case "offerCode":
                currentState.offerCode = value?.trim()
                break
        }

        this.setState({
            ...currentState,
        })
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve))

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`Update Offer`} defaultSelectedKeys={['m-update-offer']} defaultOpenKeys={["sm-sm-sys-offer", 'sm-offer']}>
                    <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                    <div style={{padding: 20}}>
                        <Row>
                            <Col xs={24} xl={8}>
                                <Card title="Update Offer" style={{margin: 10}}>
                                    <Form layout="vertical">
                                        <Form.Item label="Kode Offer">
                                            <Input value={this.state.offerCode} disabled={this.state.showFormUpdateForm} placeholder="Kode Offer" onChange={event => this.onFieldChange("offerCode", event.target.value)}/>
                                        </Form.Item>
                                        <span style={this.state.showFormUpdateForm ? {display: 'none'} : {}}>
                                            <br/>
                                            <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.cancelOffer()}> Update Offer</Button>
                                        </span>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    <Modal
                        open={this.state.cancelOfferModal}
                        title={`Update Kendaraan & Promo`}
                        style={{top: 10}}
                        onCancel={() => this.setState({cancelOfferModal: false})}
                        width={'90%'}
                        footer={[]}
                    >
                        <UpdateVehicleAndPromo update_bill={true} onCloseUpdateVehicleAndPromo={() => this.setState({cancelOfferModal: false})} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.offerCode} time={Math.floor(+new Date() / 1000)}/>
                    </Modal>

                </MainLayout>
            </React.Fragment>
        )
    }
}

export default (withAuth(withRouter(ReactiveOffer), 61))